export default defineNuxtPlugin((nuxtApp) => {

  //if (String(useRuntimeConfig().public.DEBUG_NUXT_FRONTEND) !== '1') return;

  const history: string[] = [];
  const router = useRouter();

  router.afterEach((to, from) => {
    history.push(`${new Date().toISOString().slice(11, 23)} ${from.fullPath} → ${to.fullPath}`);
    if (history.length > 20) history.shift();
  });

  nuxtApp.hook('page:start', () => console.debug('[page:start]', router.currentRoute.value.fullPath));
  nuxtApp.hook('page:finish', () => console.debug('[page:finish]', router.currentRoute.value.fullPath));

  const report = (type: string, err: unknown, extra?: unknown) => {
    console.group(`[${type}]`);
    console.error(err);
    if (extra) console.log('info:', extra);
    console.log('laatste navigaties:\n' + history.join('\n'));
    console.groupEnd();
  };

  nuxtApp.vueApp.config.errorHandler = (err, instance, info) => {
    report('vue:error', err, { info, component: instance?.$options?.name || instance?.$options?.__name });
  };

  nuxtApp.vueApp.config.warnHandler = (msg, instance, trace) => {
    console.warn('[vue:warn]', msg, trace);
  };

  nuxtApp.hook('app:error', (err) => report('app:error', err));

  window.addEventListener('unhandledrejection', (e) => report('unhandledrejection', e.reason));
});
